import {React, observer, observable, IDisposer, useEffect, classNames, useAsObservableSource} from '@api'
import {StoresInstanceContext, useVipLocalStore, VipLocalStore} from '@modules'
import {PDFViewerToolbar} from '@modules/pdf/serverRenderedPDF/components'
import {FlexLayoutComponentProps, IBaseFlexLayoutTabConfig, StoresInstance, TabNode} from '@stores'
import {autorun, runInAction} from 'mobx'
import {PDFServerRenderedContainer} from '.'
import * as css from './PDFViewerFlexLayoutTab.css'

export interface IFlexLayoutPdfTabConfig extends IBaseFlexLayoutTabConfig {
  pdfSettings: {
    selectedArtifact?: string
  }
}

/// region Store

export class PDFViewerFlexLayoutTabStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)

    const {node} = this
    if (!node.config.pdfSettings) {
      node.config.pdfSettings = {
        selectedArtifact: null
      }
    }
  }

  get node(): TabNode<IFlexLayoutPdfTabConfig> { return this.props.flexNode}

  @observable.ref overriddenStores: StoresInstance

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = [
      this.node.autorun_updateFlexNodeCustomSettings(),
      autorun(() => {
        this.node.extraData.store = this
      }),
      autorun(() => {
        if (this.overriddenStores?.disposed) {
          this.overriddenStores = null
          this.node.extraData.store = null
        }
      }),
      autorun(() => {
        // console.log(`Creating new sidebar details store`)
        const {props: {flexNode}, workspaces: {wrapperById}} = this
        // trace()
        runInAction(() => {
          this.overriddenStores = new StoresInstance(
            `PDF Viewer Tab - ${flexNode.id}`,
            null,
            flexNode.id,
            'pdf',
            {tab: flexNode})
        })
      })
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const PDFViewerFlexLayoutTabStoreContext = React.createContext<PDFViewerFlexLayoutTabStore>(null)
export const usePDFViewerFlexLayoutTabStore = () => React.useContext(PDFViewerFlexLayoutTabStoreContext)

/// endregion

/// region Components

interface MyProps extends FlexLayoutComponentProps {
  className?: string
}

export const PDFViewerFlexLayoutTab = observer<MyProps>(function PDFViewerFlexLayoutTab({className, flexNode}) {
  const obsProps = useAsObservableSource({flexNode}),
    store = useVipLocalStore((stores) => new PDFViewerFlexLayoutTabStore(stores, obsProps)),
    {overriddenStores} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <PDFViewerFlexLayoutTabStoreContext.Provider value={store}>
      {overriddenStores && <StoresInstanceContext.Provider value={overriddenStores}>
		  <div className={classNames(css.root, className)}>
			  <div className={css.toolbar}>
				  <PDFViewerToolbar />
			  </div>
			  <div className={css.pdfWrapper}>
				  <PDFServerRenderedContainer/>
			  </div>
		  </div>
	  </StoresInstanceContext.Provider>}
    </PDFViewerFlexLayoutTabStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/PDFViewerFlexLayoutTab.tsx